import type { ReactNode } from "react";
import BrowserFrame from "@/components/landing/shared/BrowserFrame";
import { cn } from "@/lib/utils";

interface DeviceFrameProps {
	className?: string;
	children: ReactNode;
}

/** Bordered device preview shell (browser chrome + content slot). */
function DeviceFrame(prop: DeviceFrameProps) {
	const { className, children } = prop;
	return (
		<div
			className={cn(
				"overflow-hidden border border-border bg-surface shadow-[var(--shadow)]",
				className,
			)}
		>
			<BrowserFrame size="sm" />
			{children}
		</div>
	);
}

export default DeviceFrame;
